export function populateMenu(jsonData){

    menuData = jsonData;
    menuTabs = jsonData.menu.data.tabs.names;
    
    function getTabs() {
        var member = $('.page_link.prototype.hidden').clone().removeClass('prototype hidden');
        member.addClass("menuLink");
        return {
            element: member,
            componentLink : member.find("a"),
            tabName: member.find(".nav_input"),
        }
    }

    function populateData(jsonData){
        var count = 0;
        $.each(menuTabs, function(index, item) {

            if(count< menuTabs.length){
                var newTab = getTabs();  
                // newTab.tabName.html(item);
                // newTab.tabName.attr('id', 'nav_'+item);
                // newTab.componentLink.attr("href", '#' + item)
                // newTab.element.css('margin','0 45px');

                if(!$(document).find(".preview").hasClass("hidden")){
                    $(".menu").addClass("u-sticky");
                    if(item.included){
                        newTab.tabName.html(item.value);
                        newTab.tabName.attr('id', 'nav_'+item.value);
                        // newTab.componentLink.attr("href", '#' + item.value)
                        newTab.componentLink.attr("id",item.value);
                        //FUNCTIONALITY FOR ACTIVE CLASS      

                        if(count == 0){
                            newTab.componentLink.addClass("active");
                        }
                        // if($(window).width()< 768){
                        //     newTab.element.css('margin','0 10px'); 
                        // }
                        // else{
                        //     newTab.element.css('margin','0 45px'); 
                        // }
                        $("ul.menu__nav").append(newTab.element); 
                    }
                }
                else{     
                    if(!item.included){
                        newTab.tabName.addClass("removeMenuItem");  
                    }
                    newTab.tabName.html(item.value);
                    newTab.tabName.attr('id', 'nav_'+item.value);
                    // newTab.componentLink.attr("href", '#' + item.value);
                    newTab.componentLink.attr("id",item.value);

                    //FUNCTIONALITY FOR ACTIVE CLASS      

                    if(count == 0){
                        newTab.componentLink.addClass("active");
                    }
                    // if($(window).width()< 768){
                    //     newTab.element.css('margin','0 10px'); 
                    // }
                    // else{
                    //     newTab.element.css('margin','0 45px'); 
                    // }
                    $("ul.menu__nav").append(newTab.element);                      
                }              
                count++;
            }

            
        });  
    }

    populateData(jsonData);

    $("ul.menu__nav").on('click', '.nav_input', function(e){
        e.preventDefault();
        $('li.menuLink>a').removeClass('active');
        $(this).parent().addClass('active');
        var y = $("section[id="+$(this).parent().attr("id") +"]").offset();    
        $(window).scrollTop(y.top-80);
    });
}